import { put, select } from 'redux-saga/effects'
import { Saga } from 'app-types'

import { analyticsActions, analyticsSelectors } from '../../redux'
import { pushDataToAnalytics } from '../../utils/analytics'

export function* submitAnalyticsDataSaga(): Saga {
  const { canSend, ...data } = yield select(analyticsSelectors.getAnalyticsData)

  if (canSend) {
    yield pushDataToAnalytics(data)
    yield put(analyticsActions.clearAfterSubmit())
  }
}
